window.initStripe = function() {
  let event = new Event('stripe-loaded')
  document.dispatchEvent(event)
}
